import { Component, Input, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';


@Component({
    selector: 'mi-selected-approval-type',
    imports: [
        ReactiveFormsModule,
    ],
    templateUrl: './selected-approval-type.html',
    styleUrl: './selected-approval-type.scss',
    standalone: true,
    encapsulation: ViewEncapsulation.None,
})
export class SelectedApprovalTypeComponent implements OnInit, OnDestroy {

    @Input() approvalTypeName!: string;
    @Input() approvalMainTypeName!: string;
    subscribtion: Subscription = new Subscription()
    selectedApprovalTypeText: any;

    constructor(private translateService: TranslateService) { }



    ngOnInit() {
        this.initText();
    }

    initText() {
        this.subscribtion.add(this.translateService.stream('approvalTypeMethod.selectedApprovalType').subscribe(translation => {
            this.selectedApprovalTypeText = translation;
        }));
    }

    approvalTypeSelectedFullName = () => {
        if (this.approvalMainTypeName == this.approvalTypeName) {
            return this.approvalTypeName;
        }
        return `${this.approvalMainTypeName} - ${this.approvalTypeName}`
    }

    ngOnDestroy(): void {
        this.subscribtion.unsubscribe();
    }
}
